require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./button"), require("./context"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./button", "./context"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./button"), require("./context")) : factory(root["./utils"], root["./svgicon"], root["./button"], root["./context"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__15__, __WEBPACK_EXTERNAL_MODULE__24__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[20],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__15__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(234);


/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Dialog = _interopRequireDefault(__webpack_require__(235));

exports["default"] = _Dialog["default"];
exports.Dialog = _Dialog["default"];

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.ThemedDialog = exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = __webpack_require__(14);

var _utils = __webpack_require__(4);

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _close_ = _interopRequireDefault(__webpack_require__(39));

var _button = _interopRequireDefault(__webpack_require__(15));

var _context = __webpack_require__(24);

var _Dialog = _interopRequireDefault(__webpack_require__(236));

var _StringResource = _interopRequireDefault(__webpack_require__(238));

var enableFocusLoop = _utils.domUtils.enableFocusLoop,
    disableFocusLoop = _utils.domUtils.disableFocusLoop,
    resetFocusLoop = _utils.domUtils.resetFocusLoop;
var isKey = _utils.keyboardUtils.isKey,
    keyNames = _utils.keyboardUtils.keyNames;
var assign = _utils.lodash.assign,
    uniqueId = _utils.lodash.uniqueId;
var sanitize = _utils.propsUtils.sanitize;

var dialogClassName = _Dialog["default"].dialogClassName.replace(/"/g, '');

function createIcon(icon) {
  if (!icon) {
    return null;
  }

  var iconComponent = typeof icon === 'string' ? /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
    focusable: false,
    iconId: icon
  }) : icon;
  return iconComponent;
}

function Header(props) {
  var children = props.children,
      title = props.title,
      others = (0, _objectWithoutPropertiesLoose2["default"])(props, ["children", "title"]);

  if (typeof children === 'string') {
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, others, {
      key: "Header",
      className: dialogClassName + "__header"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: dialogClassName + "__title __header_overflow",
      role: "heading",
      title: title || children
    }, children));
  }

  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, others, {
    key: "Header",
    className: dialogClassName + "__header"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: dialogClassName + "__title"
  }, children));
}

Header.propTypes = {
  children: _propTypes["default"].node,
  title: _propTypes["default"].string
};

function SubHeader(props) {
  var children = props.children,
      title = props.title,
      size = props.size,
      others = (0, _objectWithoutPropertiesLoose2["default"])(props, ["children", "title", "size"]);

  if (typeof children === 'string') {
    return size !== 'small' && /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, others, {
      className: dialogClassName + "__subtitle __header_overflow",
      title: title || children
    }), children);
  }

  return size !== 'small' && /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, others, {
    className: dialogClassName + "__subtitle"
  }), children);
}

SubHeader.propTypes = {
  children: _propTypes["default"].node,
  title: _propTypes["default"].string
};

function Button(props) {
  var primary = props.primary,
      others = (0, _objectWithoutPropertiesLoose2["default"])(props, ["primary"]);
  return /*#__PURE__*/_react["default"].createElement(_button["default"], (0, _extends2["default"])({
    tabIndex: 0,
    button: true,
    set: primary ? 'primary' : 'tertiary',
    title: ""
  }, others));
}

Button.propTypes = {
  label: _propTypes["default"].string,
  primary: _propTypes["default"].bool,
  onClick: _propTypes["default"].func
};

function Body(props) {
  var children = props.children,
      others = (0, _objectWithoutPropertiesLoose2["default"])(props, ["children"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, others, {
    className: dialogClassName + "__content"
  }), children);
}

Body.propTypes = {
  children: _propTypes["default"].node
};

function Footer(props) {
  var children = props.children,
      others = (0, _objectWithoutPropertiesLoose2["default"])(props, ["children"]);
  var footerChildren = [];
  var hasNonButtonChild = false;
  var primaryIndex; // sort through footer children to search for buttons and assign kind

  [].concat(children).forEach(function (child) {
    if (child) {
      var footerChild = child;

      if (child.type === Button) {
        if (child.props.primary) {
          primaryIndex = footerChildren.length;
        } else {
          footerChild = _react["default"].cloneElement(child, {
            set: 'secondary'
          });
        }
      } else if (!hasNonButtonChild) {
        hasNonButtonChild = true;
      }

      footerChildren.push(footerChild);
    }
  }); // move primary button to be the last child

  primaryIndex >= 0 && footerChildren.push(footerChildren.splice(primaryIndex, 1)[0]);
  var classNames = dialogClassName + "__footer";

  if (footerChildren.length) {
    if (footerChildren.length === 2 && !hasNonButtonChild) {
      classNames = (0, _utils.classnames)(classNames, {
        transactional: true
      });
    } else {
      classNames = (0, _utils.classnames)(classNames, {
        progress: true
      });
    }
  }

  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    "data-tid": "ba-common-dialog__footer"
  }, others, {
    className: classNames
  }), footerChildren);
}

Footer.propTypes = {
  children: _propTypes["default"].node
};

function getString(value) {
  return _StringResource["default"].get(value);
}

var Dialog = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Dialog, _Component);

  function Dialog() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_id", uniqueId('ba-common-dialog__'));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "modal", _react["default"].createRef());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "closeNode", _react["default"].createRef());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setEventDialogProp", function (e) {
      e.eventDialog = true;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onMenuKeyDown", function (e) {
      _this.modal.current.removeAttribute('hiddenOutline');

      if (_this.props.onClose && isKey(e, keyNames.ESCAPE)) {
        e.preventDefault();

        _this.props.onClose(e);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_clickawayHandler", function (e) {
      if (_this.props.onClose && _this.props.clickaway && !_this.blockerCell.contains(e.target) && e.target === _this.dialogWrapper) {
        _this.props.onClose(e);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_validMinWidth", function (minWidth) {
      var minWidthValue = minWidth.match(/\d+/);

      if (minWidth.indexOf('%') >= 0 && minWidthValue > 100) {
        return false;
      }

      if (minWidth.indexOf('px') >= 0 && minWidthValue <= 400) {
        return false;
      }

      return true;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_sortChildren", function (children) {
      // Sort the child nodes in dialog in following order:
      var ref = ['SubHeader', 'Header', 'Body', 'Footer']; // It's possible that a dialog doesn't contain all 4 elements
      // Swap-sorting cannot be used here due to incontinuous indexes
      // Pruning first (with/without SubHeader)

      if (children.filter(function (el, i) {
        return el.type.name === ref[i] || el.type.name === ref[i + 1];
      }).length === children.length) {
        return children;
      } // TODO: Find a better sorting algorithm here


      ref.forEach(function (name) {
        for (var i = 0; i < children.length; i++) {
          if (children[i].type.name === name) {
            var temp = children[i];
            children.splice(i, 1);
            children.push(temp);
            break;
          }
        }
      });
      return children;
    });
    return _this;
  }

  var _proto = Dialog.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        startingFocusIndex = _this$props.startingFocusIndex,
        ariaLabel = _this$props.ariaLabel;
    document.body.style.overflow = 'hidden';
    enableFocusLoop(this.blockerCell, startingFocusIndex, ariaLabel);
    this.node.addEventListener('click', this._setEventDialogProp);
    this.node.addEventListener('touchStart', this._setEventDialogProp);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    resetFocusLoop(this.blockerCell);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.body.style.overflow = '';
    disableFocusLoop(this.blockerCell);
    this.node.removeEventListener('click', this._setEventDialogProp);
    this.node.removeEventListener('touchStart', this._setEventDialogProp);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        size = _this$props2.size,
        width = _this$props2.width,
        minWidth = _this$props2.minWidth,
        maxWidth = _this$props2.maxWidth,
        theme = _this$props2.theme,
        getLocaleString = _this$props2.getLocaleString,
        className = _this$props2.className,
        style = _this$props2.style,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, ["size", "width", "minWidth", "maxWidth", "theme", "getLocaleString", "className", "style"]);
    var icon = createIcon("" + _close_["default"].id);
    var children = null;

    if (this.props.children && Array.isArray(this.props.children)) {
      var modalElements = this._sortChildren([].concat(this.props.children));

      children = _react["default"].Children.map(modalElements, function (child) {
        return _react["default"].cloneElement(child, {
          size: size
        });
      });
    } else {
      children = _react["default"].Children.map(this.props.children, function (child) {
        return _react["default"].cloneElement(child, {
          size: size
        });
      });
    }

    var validMinWidth = minWidth && this._validMinWidth(minWidth) && minWidth;
    var blockerMenuStyle = {
      width: width,
      maxWidth: maxWidth
    };
    var modalMenuStyle = {
      minWidth: validMinWidth
    };
    return (0, _reactDom.createPortal)( /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme,
      ref: function ref(node) {
        _this2.node = node;
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      ref: function ref(_ref2) {
        _this2.dialogWrapper = _ref2;
      },
      onClick: this._clickawayHandler,
      onKeyDown: this._onMenuKeyDown,
      className: dialogClassName + " " + className,
      style: style
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: blockerMenuStyle,
      ref: function ref(_ref) {
        _this2.blockerCell = _ref;
      },
      "data-tid": "ba-common-dialog__blocker",
      className: dialogClassName + "__blockerCell"
    }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
      style: modalMenuStyle
    }, sanitize(others, Dialog), {
      role: "dialog",
      "aria-modal": "true",
      ref: this.modal,
      tabIndex: "-1",
      className: dialogClassName + "__modal " + ((size === 'small' || size === 'large') && !width ? (0, _utils.classnames)(size) : '')
    }), children, this.props.onClose && /*#__PURE__*/_react["default"].createElement("span", {
      ref: this.closeNode,
      className: dialogClassName + "__closeX"
    }, /*#__PURE__*/_react["default"].createElement(Button, {
      "data-tid": "ba-common-dialog__close-x",
      icon: icon,
      variant: "icon",
      title: getLocaleString('close'),
      onClick: this.props.onClose,
      "aria-label": getLocaleString('close')
    })))))), document.body);
  };

  return Dialog;
}(_react.Component);

(0, _defineProperty2["default"])(Dialog, "propTypes", {
  /** Choose from two fixed sizes */
  size: _propTypes["default"].oneOf(['small', 'large']),

  /** Custom width in px or % */
  width: _propTypes["default"].string,

  /** Custom min width in px or % */
  minWidth: _propTypes["default"].string,

  /** Custom max width in px or % */
  maxWidth: _propTypes["default"].string,

  /** Close dialog on clicking outside */
  clickaway: _propTypes["default"].bool,

  /** Header, SubHeader, Body and Footer inside the dialog */
  children: _propTypes["default"].node,

  /** Callback function when dialog is closed */
  onClose: _propTypes["default"].func,

  /** Custom style theme */
  theme: _propTypes["default"].string,

  /** Get Locale */
  getLocaleString: _propTypes["default"].func,

  /** Custom class name(s) */
  className: _propTypes["default"].string,

  /** Custom CSS styles */
  style: _propTypes["default"].object,

  /** Non-negative value sets the focus at the target node index */
  startingFocusIndex: _propTypes["default"].number,

  /** aria-label string for initially focused div */
  ariaLabel: _propTypes["default"].string
});
(0, _defineProperty2["default"])(Dialog, "defaultProps", {
  clickaway: false,
  theme: 'ba-theme-default',
  getLocaleString: getString,
  className: '',
  style: {},
  startingFocusIndex: -1
});

var _default = assign(Dialog, {
  Header: Header,
  SubHeader: SubHeader,
  Body: Body,
  Footer: Footer,
  Button: Button
});

exports["default"] = _default;
var ThemedDialog = assign((0, _context.withContext)('theme')(Dialog), {
  Header: Header,
  SubHeader: SubHeader,
  Body: Body,
  Footer: Footer,
  Button: Button
});
exports.ThemedDialog = ThemedDialog;

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(237);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-dialog{position:fixed;top:0;left:0;bottom:0;right:0;z-index:9000;display:flex;overflow-y:auto;overflow-x:hidden;padding:32px 0;background-color:rgba(22,22,22,0.5);background-color:hsla(var(--overlay-01-h, 0), var(--overlay-01-s, 0%), var(--overlay-01-l, 8.62745%), 0.5)}.ba-common-dialog__blockerCell{visibility:visible;position:relative;height:auto;margin:auto;z-index:9000;text-align:center;display:flex;align-self:flex-start;align-items:center;justify-content:center;min-width:400px;max-width:calc(100% - 64px)}.ba-common-dialog__modal{display:inline-flex;background-color:#fff;flex-direction:column;text-align:left;position:relative;width:100%;padding:1rem 0 0 0}.ba-common-dialog__modal.is-small{width:450px;max-height:240px}.ba-common-dialog__modal.is-small .ba-common-dialog__content{overflow:auto;min-height:72px;max-height:72px}.ba-common-dialog__modal.is-large{width:680px;max-height:496px}.ba-common-dialog__modal.is-large .ba-common-dialog__content{overflow:auto;max-height:300px}.ba-common-dialog__modal:focus{outline:0}.ba-common-dialog__header{color:#161616;height:auto;font-size:1.25rem;font-weight:400;line-height:1.75rem;letter-spacing:0;padding-left:1rem;margin-bottom:16px;max-width:calc(100% - 48px)}[dir=\"ltr\"].ba-common-dialog__header{padding-right:1rem;text-align:left}[dir=\"rtl\"].ba-common-dialog__header{padding-right:0;padding-left:1rem;text-align:right}[dir=\"ltr\"] .ba-common-dialog__header,.ba-common-dialog__header{padding-right:1rem;text-align:left}[dir=\"rtl\"] .ba-common-dialog__header{padding-right:0;padding-left:1rem;text-align:right}.ba-common-dialog__subtitle{font-size:.75rem;font-weight:400;line-height:1rem;letter-spacing:.32px;color:#525252;padding-left:1rem;margin-bottom:.25rem}[dir=\"ltr\"].ba-common-dialog__subtitle{text-align:left}[dir=\"rtl\"].ba-common-dialog__subtitle{text-align:right}[dir=\"ltr\"] .ba-common-dialog__subtitle,.ba-common-dialog__subtitle{text-align:left}[dir=\"rtl\"] .ba-common-dialog__subtitle{text-align:right}.ba-common-dialog .__header_overflow{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;line-height:normal}.ba-common-dialog__closeX{position:absolute;margin:0;cursor:pointer;background-color:transparent;top:0}[dir=\"ltr\"].ba-common-dialog__closeX{right:0}[dir=\"rtl\"].ba-common-dialog__closeX{right:auto;left:0}[dir=\"ltr\"] .ba-common-dialog__closeX,.ba-common-dialog__closeX{right:0}[dir=\"rtl\"] .ba-common-dialog__closeX{right:auto;left:0}.ba-common-dialog__closeX:hover{background-color:#e5e5e5}.ba-common-dialog__closeX:focus{outline:none;border-color:#a8c0f3}.ba-common-dialog__content{font-size:.875rem;font-weight:400;line-height:1.25rem;letter-spacing:.16px;position:relative;line-height:1.25rem;color:#161616;flex:1 1 auto;height:100%;margin-bottom:48px;padding-right:1rem;padding-left:1rem}[dir=\"ltr\"].ba-common-dialog__content{text-align:left}[dir=\"rtl\"].ba-common-dialog__content{text-align:right}[dir=\"ltr\"] .ba-common-dialog__content,.ba-common-dialog__content{text-align:left}[dir=\"rtl\"] .ba-common-dialog__content{text-align:right}.ba-common-dialog__content:after{visibility:hidden;display:block;font-size:0;content:\" \";clear:both;height:0}.ba-common-dialog__footer{border:none;display:flex;justify-content:flex-end;align-items:flex-end;margin-top:auto;height:4rem}.ba-common-dialog__footer.is-progress:not(button){padding-left:1rem}.ba-common-dialog__footer.is-progress button{flex:0 1 25%;max-width:none;height:4rem;margin:0;padding-top:1rem;padding-bottom:2rem}.ba-common-dialog__footer.is-progress button:not(:first-child){margin-left:1px}.ba-common-dialog__footer.is-transactional button{flex:0 1 50%;max-width:none;height:4rem;margin:0;padding-top:1rem;padding-bottom:2rem}.ba-common-dialog__footer.is-transactional button:not(:first-child){margin-left:1px}.ba-common-dialog__footer.errorDialog{display:flex;justify-content:center;padding:0;height:auto}.ba-common-dialog__footer:after{visibility:hidden;display:block;font-size:0;content:\" \";clear:both;height:0}.ba--highContrast .ba-common-dialog__modal{border:1px solid currentColor}.ba-common-dialog__modal[hiddenOutline] .is-focus{outline:none}.ba-common-dialog__blockerCell{color:#343334}.ba-common-dialog__modal{border-top-color:#002d9c;border-top-color:hsla(var(--active-primary-h, 222.69231), var(--active-primary-s, 100%), var(--active-primary-l, 30.58824%), 1)}@media screen and (-ms-high-contrast: active){.ba-common-dialog__modal{border-left:1px solid #fff;border-right:1px solid #fff;border-bottom:1px solid #fff}}\n", ""]);

// exports
exports.locals = {
	"dialogClassName": "\"ba-common-dialog\""
};

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _utils = __webpack_require__(4);

var _DialogResources = _interopRequireDefault(__webpack_require__(239));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = new _utils.StringResource(_DialogResources["default"]);

exports["default"] = _default;

/***/ }),

/***/ 239:
/***/ (function(module, exports) {

var amdi18n={"__root":{"close":"Close"},"__cs":{"close":"Zavřít"},"__da":{"close":"Luk"},"__de":{"close":"Schließen"},"__es":{"close":"Cerrar"},"__fi":{"close":"Sulje"},"__fr":{"close":"Fermer"},"__hr":{"close":"Zatvori"},"__hu":{"close":"Bezárás"},"__it":{"close":"Chiudi"},"__ja":{"close":"閉じる"},"__kk":{"close":"Жабу"},"__ko":{"close":"닫기"},"__nb":{"close":"Lukk"},"__nl":{"close":"Sluiten"},"__no":{"close":"Lukk"},"__pl":{"close":"Zamknij"},"__pt":{"close":"Fechar"},"__pt-br":{"close":"Fechar"},"__ro":{"close":"Închidere"},"__ru":{"close":"Закрыть"},"__sl":{"close":"Zapri"},"__sv":{"close":"Stäng"},"__th":{"close":"ปิด"},"__tr":{"close":"Kapat"},"__zh":{"close":"关闭"},"__zh-cn":{"close":"关闭"},"__zh-hk":{"close":"關閉"},"__zh-mo":{"close":"關閉"},"__zh-sg":{"close":"关闭"},"__zh-tw":{"close":"關閉"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__24__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/close_16");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[233,0]]]);
});